import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
  Badge,
  Avatar,
  Paper,
  Divider
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterIcon,
  Widgets as WidgetIcon,
  ViewModule as GridIcon,
  ViewList as ListIcon,
  Star as StarIcon,
  Visibility as PreviewIcon,
  Add as AddIcon,
  Close as CloseIcon,
  TrendingUp as TrendingIcon,
  ArrowForward as ArrowIcon,
  CheckCircle as CheckIcon,
  Code as CodeIcon,
  Palette as PaletteIcon,
  Speed as SpeedIcon,
  Category as CategoryIcon,
  Label as TagIcon,
  Image as ImageIcon,
  VideoLibrary as VideoIcon,
  AttachMoney as MoneyIcon,
  WbSunny as WeatherIcon,
  SportsBasketball as SportsIcon,
  AutoAwesome as MagicIcon
} from '@mui/icons-material';

const WidgetGalleryPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('grid');
  const [openModal, setOpenModal] = useState(false);
  const [selectedWidget, setSelectedWidget] = useState(null);
  const [hoveredWidget, setHoveredWidget] = useState(null);

  // Widget Kategorileri
  const categories = [
    { id: 'all', name: 'Tümü', count: 70, icon: <WidgetIcon />, color: '#6c757d' },
    { id: 'manset', name: 'Ana Manşet', count: 10, icon: '📰', color: '#3b82f6' },
    { id: 'liste', name: 'Haber Listeleri', count: 30, icon: '📋', color: '#10b981' },
    { id: 'kategori', name: 'Kategori', count: 5, icon: '📂', color: '#f59e0b' },
    { id: 'yazar', name: 'Yazar', count: 3, icon: '✍️', color: '#8b5cf6' },
    { id: 'finans', name: 'Finans', count: 8, icon: '💱', color: '#ec4899' },
    { id: 'hava', name: 'Hava Durumu', count: 4, icon: '☀️', color: '#06b6d4' },
    { id: 'spor', name: 'Spor', count: 3, icon: '⚽', color: '#ef4444' },
    { id: 'extra', name: 'Ekstra', count: 7, icon: '🎯', color: '#f97316' }
  ];

  // Örnek Widget'lar
  const widgets = [
    {
      id: 1,
      name: 'Ana Manşet Slider 1',
      category: 'manset',
      description: 'Otomatik geçişli, tam genişlik manşet slider',
      image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400&h=250&fit=crop',
      rating: 4.8,
      uses: 1250,
      color: '#3b82f6',
      tags: ['Slider', 'Autoplay', 'Responsive'],
      popular: true,
      new: false
    },
    {
      id: 2,
      name: 'Haber Grid 3x2',
      category: 'liste',
      description: '3 sütun, 2 satır haber grid düzeni',
      image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=250&fit=crop',
      rating: 4.9,
      uses: 2100,
      color: '#10b981',
      tags: ['Grid', 'Responsive', 'Modern'],
      popular: true,
      new: false
    },
    {
      id: 3,
      name: 'Döviz Kuru Widget',
      category: 'finans',
      description: 'Canlı döviz kurları gösterimi',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=250&fit=crop',
      rating: 4.7,
      uses: 890,
      color: '#ec4899',
      tags: ['Live Data', 'API', 'Real-time'],
      popular: false,
      new: true
    },
    {
      id: 4,
      name: 'Kategori Tab Widget',
      category: 'kategori',
      description: 'Tab\'lı kategori navigasyonu',
      image: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?w=400&h=250&fit=crop',
      rating: 4.6,
      uses: 1450,
      color: '#f59e0b',
      tags: ['Tabs', 'Navigation', 'Interactive'],
      popular: true,
      new: false
    },
    {
      id: 5,
      name: 'Köşe Yazarı Slider',
      category: 'yazar',
      description: 'Yazar profilleri carousel',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&h=250&fit=crop',
      rating: 4.5,
      uses: 680,
      color: '#8b5cf6',
      tags: ['Carousel', 'Profile', 'Author'],
      popular: false,
      new: false
    },
    {
      id: 6,
      name: 'Hava Durumu Card',
      category: 'hava',
      description: '5 günlük hava durumu tahmini',
      image: 'https://images.unsplash.com/photo-1592210454359-9043f067919b?w=400&h=250&fit=crop',
      rating: 4.4,
      uses: 520,
      color: '#06b6d4',
      tags: ['Weather', 'API', 'Forecast'],
      popular: false,
      new: true
    },
    {
      id: 7,
      name: 'Spor Lig Tablosu',
      category: 'spor',
      description: 'Canlı lig puan durumu',
      image: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=400&h=250&fit=crop',
      rating: 4.7,
      uses: 750,
      color: '#ef4444',
      tags: ['Sports', 'Live', 'Table'],
      popular: false,
      new: false
    },
    {
      id: 8,
      name: 'Newsletter Widget',
      category: 'extra',
      description: 'E-posta abonelik formu',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=250&fit=crop',
      rating: 4.6,
      uses: 1100,
      color: '#f97316',
      tags: ['Form', 'Email', 'Subscribe'],
      popular: true,
      new: false
    },
    {
      id: 9,
      name: 'Timeline Haber Widget',
      category: 'liste',
      description: 'Kronolojik haber akışı',
      image: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=400&h=250&fit=crop',
      rating: 4.8,
      uses: 980,
      color: '#10b981',
      tags: ['Timeline', 'Vertical', 'Modern'],
      popular: false,
      new: true
    }
  ];

  // Filtrelenmiş widget'lar
  const filteredWidgets = widgets.filter(widget => {
    const matchCategory = selectedCategory === 'all' || widget.category === selectedCategory;
    const matchSearch = widget.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                       widget.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCategory && matchSearch;
  });

  // Popüler Widget'lar
  const popularWidgets = widgets.filter(w => w.popular).slice(0, 3);

  // İstatistikler
  const stats = [
    { icon: <WidgetIcon />, value: '70+', label: 'Toplam Widget', color: '#3b82f6' },
    { icon: <TrendingIcon />, value: '15+', label: 'Yeni Eklenen', color: '#10b981' },
    { icon: <StarIcon />, value: '4.8', label: 'Ortalama Puan', color: '#f59e0b' },
    { icon: <CheckIcon />, value: '5K+', label: 'Aktif Kullanım', color: '#8b5cf6' }
  ];

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          pt: { xs: 12, md: 16 },
          pb: { xs: 10, md: 15 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated Blobs */}
        <Box
          sx={{
            position: 'absolute',
            top: -150,
            right: -150,
            width: 500,
            height: 500,
            background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 10s ease-in-out infinite'
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            bottom: -100,
            left: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 12s ease-in-out infinite reverse'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Chip
              label="WİDGET GALERİSİ"
              icon={<MagicIcon sx={{ fontSize: '1rem' }} />}
              sx={{
                background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.2), rgba(247, 147, 30, 0.2))',
                color: '#ff6b35',
                border: '1px solid rgba(255, 107, 53, 0.3)',
                backdropFilter: 'blur(10px)',
                fontSize: '0.85rem',
                fontWeight: 600,
                mb: 3,
                px: 2,
                py: 2.5
              }}
            />
            
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '4.5rem' },
                fontWeight: 900,
                color: 'white',
                mb: 3,
                lineHeight: 1.1
              }}
            >
              70+ Profesyonel{' '}
              <span style={{ 
                background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Widget Galerisi
              </span>
            </Typography>

            <Typography
              variant="h5"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                fontSize: { xs: '1.1rem', md: '1.4rem' },
                lineHeight: 1.6,
                mb: 5,
                maxWidth: 800,
                mx: 'auto'
              }}
            >
              Haber siteniz için özel tasarlanmış, hazır widget koleksiyonu. 
              Sürükle-bırak ile anında kullanın.
            </Typography>

            {/* Search Bar */}
            <Box sx={{ maxWidth: 600, mx: 'auto', mb: 5 }}>
              <TextField
                fullWidth
                placeholder="Widget ara... (örn: slider, grid, finans)"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    background: 'rgba(255,255,255,0.95)',
                    borderRadius: '50px',
                    fontSize: '1.1rem',
                    '& fieldset': {
                      borderColor: 'transparent'
                    },
                    '&:hover fieldset': {
                      borderColor: '#ff6b35'
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#ff6b35',
                      borderWidth: 2
                    }
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#ff6b35', fontSize: '1.5rem' }} />
                    </InputAdornment>
                  ),
                  endAdornment: searchQuery && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => setSearchQuery('')}>
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Box>

            {/* Stats */}
            <Grid container spacing={3} sx={{ maxWidth: 900, mx: 'auto' }}>
              {stats.map((stat, index) => (
                <Grid item xs={6} sm={3} key={index}>
                  <Box
                    sx={{
                      textAlign: 'center',
                      p: 2,
                      borderRadius: 3,
                      background: 'rgba(255,255,255,0.05)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: 'rgba(255,255,255,0.1)',
                        transform: 'translateY(-4px)'
                      }
                    }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 50,
                        height: 50,
                        borderRadius: '50%',
                        background: `${stat.color}20`,
                        color: stat.color,
                        mb: 1.5,
                        fontSize: '1.5rem'
                      }}
                    >
                      {stat.icon}
                    </Box>
                    <Typography
                      sx={{
                        color: 'white',
                        fontSize: '1.8rem',
                        fontWeight: 800,
                        mb: 0.5
                      }}
                    >
                      {stat.value}
                    </Typography>
                    <Typography
                      sx={{
                        color: 'rgba(255,255,255,0.6)',
                        fontSize: '0.85rem'
                      }}
                    >
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>

        {/* Dalga Geçişi */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            overflow: 'hidden',
            lineHeight: 0
          }}
        >
          <svg
            viewBox="0 0 1440 400"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '250px', display: 'block' }}
          >
            <path
              d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,176C1248,160,1344,128,1392,112L1440,96L1440,400L0,400Z"
              fill="#f8f9fa"
            />
          </svg>
        </Box>
      </Box>

      {/* Kategori Filtreleri */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
          py: 4,
          borderBottom: '1px solid #e2e8f0',
          position: 'sticky',
          top: 0,
          zIndex: 10,
          backdropFilter: 'blur(10px)'
        }}
      >
        <Container maxWidth="xl">
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Kategori Tabs */}
            <Box
              sx={{
                display: 'flex',
                gap: 1.5,
                flexWrap: 'wrap',
                justifyContent: { xs: 'center', md: 'flex-start' }
              }}
            >
              {categories.map((cat) => (
                <Chip
                  key={cat.id}
                  icon={typeof cat.icon === 'string' ? undefined : cat.icon}
                  label={
                    <Stack direction="row" spacing={1} alignItems="center">
                      {typeof cat.icon === 'string' && (
                        <span style={{ fontSize: '1.2rem' }}>{cat.icon}</span>
                      )}
                      <span>{cat.name}</span>
                      <Badge
                        badgeContent={cat.count}
                        sx={{
                          '& .MuiBadge-badge': {
                            background: selectedCategory === cat.id ? 'white' : cat.color,
                            color: selectedCategory === cat.id ? cat.color : 'white',
                            fontWeight: 700,
                            fontSize: '0.7rem'
                          }
                        }}
                      />
                    </Stack>
                  }
                  onClick={() => setSelectedCategory(cat.id)}
                  sx={{
                    px: 2,
                    py: 2.5,
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    borderRadius: '50px',
                    background: selectedCategory === cat.id ? cat.color : 'white',
                    color: selectedCategory === cat.id ? 'white' : '#495057',
                    border: selectedCategory === cat.id ? 'none' : '2px solid #e2e8f0',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: selectedCategory === cat.id ? cat.color : `${cat.color}15`,
                      color: selectedCategory === cat.id ? 'white' : cat.color,
                      borderColor: cat.color,
                      transform: 'translateY(-2px)',
                      boxShadow: `0 4px 12px ${cat.color}30`
                    }
                  }}
                />
              ))}
            </Box>

            {/* View Mode Toggle */}
            <Stack direction="row" spacing={1}>
              <IconButton
                onClick={() => setViewMode('grid')}
                sx={{
                  background: viewMode === 'grid' ? '#ff6b35' : 'white',
                  color: viewMode === 'grid' ? 'white' : '#6c757d',
                  border: '2px solid',
                  borderColor: viewMode === 'grid' ? '#ff6b35' : '#e2e8f0',
                  '&:hover': {
                    background: viewMode === 'grid' ? '#f7931e' : '#f8f9fa'
                  }
                }}
              >
                <GridIcon />
              </IconButton>
              <IconButton
                onClick={() => setViewMode('list')}
                sx={{
                  background: viewMode === 'list' ? '#ff6b35' : 'white',
                  color: viewMode === 'list' ? 'white' : '#6c757d',
                  border: '2px solid',
                  borderColor: viewMode === 'list' ? '#ff6b35' : '#e2e8f0',
                  '&:hover': {
                    background: viewMode === 'list' ? '#f7931e' : '#f8f9fa'
                  }
                }}
              >
                <ListIcon />
              </IconButton>
            </Stack>
          </Stack>
        </Container>
      </Box>

      {/* Öne Çıkan Widget'lar */}
      {selectedCategory === 'all' && !searchQuery && (
        <Box
          sx={{
            background: 'white',
            py: { xs: 6, md: 8 }
          }}
        >
          <Container maxWidth="xl">
            <Box sx={{ mb: 5 }}>
              <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                <Box
                  sx={{
                    width: 50,
                    height: 50,
                    borderRadius: 2,
                    background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '1.5rem'
                  }}
                >
                  <StarIcon />
                </Box>
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 800,
                      color: '#1a1a2e'
                    }}
                  >
                    Öne Çıkan Widget'lar
                  </Typography>
                  <Typography
                    sx={{
                      color: '#6c757d',
                      fontSize: '0.95rem'
                    }}
                  >
                    En çok kullanılan ve beğenilen widget'lar
                  </Typography>
                </Box>
              </Stack>
            </Box>

            <Grid container spacing={4}>
              {popularWidgets.map((widget, index) => (
                <Grid item xs={12} md={4} key={widget.id}>
                  <Card
                    sx={{
                      height: '100%',
                      borderRadius: 4,
                      overflow: 'hidden',
                      border: '2px solid #e2e8f0',
                      position: 'relative',
                      transition: 'all 0.4s ease',
                      cursor: 'pointer',
                      '&:hover': {
                        transform: 'translateY(-12px)',
                        boxShadow: `0 24px 48px ${widget.color}30`,
                        borderColor: widget.color,
                        '& .widget-image': {
                          transform: 'scale(1.1)'
                        },
                        '& .widget-overlay': {
                          opacity: 1
                        }
                      }
                    }}
                  >
                    {/* Popular Badge */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 15,
                        right: 15,
                        zIndex: 3,
                        background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                        color: 'white',
                        px: 2,
                        py: 0.8,
                        borderRadius: '50px',
                        fontSize: '0.75rem',
                        fontWeight: 700,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        boxShadow: '0 4px 12px rgba(255, 107, 53, 0.4)'
                      }}
                    >
                      <StarIcon sx={{ fontSize: '1rem' }} />
                      POPÜLER
                    </Box>

                    {/* Image */}
                    <Box
                      sx={{
                        position: 'relative',
                        height: 280,
                        overflow: 'hidden'
                      }}
                    >
                      <img
                        className="widget-image"
                        src={widget.image}
                        alt={widget.name}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.6s ease'
                        }}
                      />

                      {/* Hover Overlay */}
                      <Box
                        className="widget-overlay"
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: 'rgba(0,0,0,0.7)',
                          backdropFilter: 'blur(5px)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 2,
                          opacity: 0,
                          transition: 'opacity 0.3s ease'
                        }}
                      >
                        <Button
                          variant="contained"
                          startIcon={<PreviewIcon />}
                          onClick={() => {
                            setSelectedWidget(widget);
                            setOpenModal(true);
                          }}
                          sx={{
                            background: 'white',
                            color: widget.color,
                            fontWeight: 600,
                            borderRadius: '50px',
                            px: 3,
                            '&:hover': {
                              background: '#f8f9fa'
                            }
                          }}
                        >
                          Önizle
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          sx={{
                            background: widget.color,
                            color: 'white',
                            fontWeight: 600,
                            borderRadius: '50px',
                            px: 3,
                            '&:hover': {
                              background: widget.color,
                              filter: 'brightness(1.1)'
                            }
                          }}
                        >
                          Kullan
                        </Button>
                      </Box>
                    </Box>

                    <CardContent sx={{ p: 3 }}>
                      {/* Title & Category */}
                      <Stack direction="row" justifyContent="space-between" alignItems="start" mb={2}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#1a1a2e',
                            flex: 1
                          }}
                        >
                          {widget.name}
                        </Typography>
                        <Chip
                          label={categories.find(c => c.id === widget.category)?.name}
                          size="small"
                          sx={{
                            background: `${widget.color}15`,
                            color: widget.color,
                            fontWeight: 600,
                            fontSize: '0.7rem'
                          }}
                        />
                      </Stack>

                      {/* Description */}
                      <Typography
                        sx={{
                          color: '#6c757d',
                          fontSize: '0.95rem',
                          lineHeight: 1.6,
                          mb: 2
                        }}
                      >
                        {widget.description}
                      </Typography>

                      {/* Tags */}
                      <Stack direction="row" spacing={1} mb={3} flexWrap="wrap" useFlexGap>
                        {widget.tags.map((tag, idx) => (
                          <Chip
                            key={idx}
                            label={tag}
                            size="small"
                            sx={{
                              background: '#f1f3f5',
                              color: '#495057',
                              fontSize: '0.75rem',
                              height: 24,
                              '&:hover': {
                                background: `${widget.color}15`,
                                color: widget.color
                              }
                            }}
                          />
                        ))}
                      </Stack>

                      <Divider sx={{ mb: 2 }} />

                      {/* Stats */}
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" spacing={2}>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <StarIcon sx={{ fontSize: '1rem', color: '#f59e0b' }} />
                            <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#1a1a2e' }}>
                              {widget.rating}
                            </Typography>
                          </Stack>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <CheckIcon sx={{ fontSize: '1rem', color: '#10b981' }} />
                            <Typography sx={{ fontSize: '0.85rem', color: '#6c757d' }}>
                              {widget.uses} kullanım
                            </Typography>
                          </Stack>
                        </Stack>

                        <IconButton
                          size="small"
                          sx={{
                            color: widget.color,
                            '&:hover': {
                              background: `${widget.color}15`
                            }
                          }}
                        >
                          <ArrowIcon />
                        </IconButton>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      )}

      {/* Tüm Widget'lar */}
      <Box
        sx={{
          background: 'white',
          py: { xs: 6, md: 8 }
        }}
      >
        <Container maxWidth="xl">
          {/* Sonuç Başlığı */}
          <Box sx={{ mb: 5 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 800,
                    color: '#1a1a2e',
                    mb: 0.5
                  }}
                >
                  {selectedCategory === 'all' ? 'Tüm Widget\'lar' : categories.find(c => c.id === selectedCategory)?.name}
                </Typography>
                <Typography
                  sx={{
                    color: '#6c757d',
                    fontSize: '0.95rem'
                  }}
                >
                  {filteredWidgets.length} widget bulundu
                </Typography>
              </Box>

              <Button
                variant="outlined"
                startIcon={<FilterIcon />}
                sx={{
                  borderColor: '#e2e8f0',
                  color: '#495057',
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    borderColor: '#ff6b35',
                    color: '#ff6b35',
                    background: 'rgba(255, 107, 53, 0.05)'
                  }
                }}
              >
                Filtrele
              </Button>
            </Stack>
          </Box>

          {/* Widget Grid */}
          <Grid container spacing={3}>
            {filteredWidgets.map((widget, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={widget.id}>
                <Card
                  onMouseEnter={() => setHoveredWidget(index)}
                  onMouseLeave={() => setHoveredWidget(null)}
                  sx={{
                    height: '100%',
                    borderRadius: 3,
                    overflow: 'hidden',
                    border: '2px solid #e2e8f0',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: `0 12px 32px ${widget.color}25`,
                      borderColor: widget.color,
                      '& .widget-thumb': {
                        transform: 'scale(1.05)'
                      },
                      '& .quick-actions': {
                        opacity: 1,
                        transform: 'translateY(0)'
                      }
                    }
                  }}
                >
                  {/* Badges */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 10,
                      left: 10,
                      zIndex: 2,
                      display: 'flex',
                      gap: 1
                    }}
                  >
                    {widget.new && (
                      <Chip
                        label="YENİ"
                        size="small"
                        sx={{
                          background: '#10b981',
                          color: 'white',
                          fontWeight: 700,
                          fontSize: '0.7rem',
                          height: 24
                        }}
                      />
                    )}
                    {widget.popular && (
                      <Chip
                        icon={<StarIcon sx={{ fontSize: '0.9rem' }} />}
                        label="POPÜLER"
                        size="small"
                        sx={{
                          background: '#ff6b35',
                          color: 'white',
                          fontWeight: 700,
                          fontSize: '0.7rem',
                          height: 24
                        }}
                      />
                    )}
                  </Box>

                  {/* Thumbnail */}
                  <Box
                    sx={{
                      position: 'relative',
                      height: 200,
                      overflow: 'hidden',
                      background: '#f8f9fa'
                    }}
                  >
                    <img
                      className="widget-thumb"
                      src={widget.image}
                      alt={widget.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.4s ease'
                      }}
                    />

                    {/* Quick Actions */}
                    <Box
                      className="quick-actions"
                      sx={{
                        position: 'absolute',
                        bottom: 10,
                        left: 10,
                        right: 10,
                        display: 'flex',
                        gap: 1,
                        opacity: 0,
                        transform: 'translateY(10px)',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        size="small"
                        startIcon={<PreviewIcon />}
                        onClick={() => {
                          setSelectedWidget(widget);
                          setOpenModal(true);
                        }}
                        sx={{
                          background: 'white',
                          color: widget.color,
                          fontWeight: 600,
                          borderRadius: '50px',
                          fontSize: '0.8rem',
                          '&:hover': {
                            background: '#f8f9fa'
                          }
                        }}
                      >
                        Önizle
                      </Button>
                      <Button
                        fullWidth
                        variant="contained"
                        size="small"
                        startIcon={<AddIcon />}
                        sx={{
                          background: widget.color,
                          color: 'white',
                          fontWeight: 600,
                          borderRadius: '50px',
                          fontSize: '0.8rem',
                          '&:hover': {
                            background: widget.color,
                            filter: 'brightness(1.1)'
                          }
                        }}
                      >
                        Kullan
                      </Button>
                    </Box>
                  </Box>

                  <CardContent sx={{ p: 2.5 }}>
                    {/* Title */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: '#1a1a2e',
                        fontSize: '1rem',
                        mb: 1
                      }}
                    >
                      {widget.name}
                    </Typography>

                    {/* Description */}
                    <Typography
                      sx={{
                        color: '#6c757d',
                        fontSize: '0.85rem',
                        lineHeight: 1.5,
                        mb: 2,
                        minHeight: 40
                      }}
                    >
                      {widget.description}
                    </Typography>

                    {/* Tags */}
                    <Stack direction="row" spacing={0.5} mb={2} flexWrap="wrap" useFlexGap>
                      {widget.tags.slice(0, 2).map((tag, idx) => (
                        <Chip
                          key={idx}
                          label={tag}
                          size="small"
                          sx={{
                            background: '#f1f3f5',
                            color: '#495057',
                            fontSize: '0.7rem',
                            height: 22
                          }}
                        />
                      ))}
                    </Stack>

                    {/* Stats */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Stack direction="row" spacing={1.5} alignItems="center">
                        <Stack direction="row" spacing={0.5} alignItems="center">
                          <StarIcon sx={{ fontSize: '0.9rem', color: '#f59e0b' }} />
                          <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#1a1a2e' }}>
                            {widget.rating}
                          </Typography>
                        </Stack>
                        <Typography sx={{ fontSize: '0.75rem', color: '#adb5bd' }}>•</Typography>
                        <Typography sx={{ fontSize: '0.8rem', color: '#6c757d' }}>
                          {widget.uses}
                        </Typography>
                      </Stack>

                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          background: widget.color
                        }}
                      />
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Widget Karşılaştırma */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#ff6b35',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              KARŞILAŞTIRMA
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 2,
                mt: 2
              }}
            >
              Widget Türlerini{' '}
              <span style={{ color: '#ff6b35' }}>Karşılaştırın</span>
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Her widget kategorisinin özelliklerini ve kullanım alanlarını keşfedin
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {[
              {
                category: 'Ana Manşet',
                icon: '📰',
                color: '#3b82f6',
                widgets: '10+ Varyasyon',
                features: ['Slider', 'Video', 'Hero', 'Carousel'],
                bestFor: 'Anasayfa manşet alanı',
                image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400&h=300&fit=crop'
              },
              {
                category: 'Haber Listeleri',
                icon: '📋',
                color: '#10b981',
                widgets: '30+ Varyasyon',
                features: ['Grid', 'List', 'Card', 'Timeline'],
                bestFor: 'İçerik listeleme alanları',
                image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop'
              },
              {
                category: 'Finans Widget\'ları',
                icon: '💱',
                color: '#ec4899',
                widgets: '8+ Varyasyon',
                features: ['Döviz', 'Altın', 'Kripto', 'Borsa'],
                bestFor: 'Ekonomi sayfaları',
                image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=300&fit=crop'
              }
            ].map((item, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  sx={{
                    height: '100%',
                    background: 'rgba(255,255,255,0.05)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: 4,
                    overflow: 'hidden',
                    transition: 'all 0.4s ease',
                    '&:hover': {
                      transform: 'translateY(-12px)',
                      borderColor: item.color,
                      boxShadow: `0 20px 40px ${item.color}30`,
                      '& .category-image': {
                        transform: 'scale(1.1)'
                      }
                    }
                  }}
                >
                  {/* Image */}
                  <Box
                    sx={{
                      position: 'relative',
                      height: 200,
                      overflow: 'hidden'
                    }}
                  >
                    <img
                      className="category-image"
                      src={item.image}
                      alt={item.category}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.6s ease'
                      }}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: `linear-gradient(180deg, transparent 0%, ${item.color}40 100%)`
                      }}
                    />
                    {/* Icon */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 20,
                        left: 20,
                        fontSize: '3rem'
                      }}
                    >
                      {item.icon}
                    </Box>
                  </Box>

                  <CardContent sx={{ p: 3 }}>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        color: 'white',
                        mb: 1
                      }}
                    >
                      {item.category}
                    </Typography>

                    <Chip
                      label={item.widgets}
                      sx={{
                        background: `${item.color}30`,
                        color: item.color,
                        fontWeight: 700,
                        fontSize: '0.8rem',
                        mb: 3
                      }}
                    />

                    <Typography
                      sx={{
                        color: 'rgba(255,255,255,0.7)',
                        fontSize: '0.9rem',
                        mb: 2
                      }}
                    >
                      <strong style={{ color: 'white' }}>En İyi Kullanım:</strong> {item.bestFor}
                    </Typography>

                    <Stack spacing={1}>
                      {item.features.map((feature, idx) => (
                        <Stack key={idx} direction="row" spacing={1} alignItems="center">
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              borderRadius: '50%',
                              background: item.color
                            }}
                          />
                          <Typography
                            sx={{
                              color: 'rgba(255,255,255,0.8)',
                              fontSize: '0.85rem'
                            }}
                          >
                            {feature}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>

                    <Button
                      fullWidth
                      variant="outlined"
                      endIcon={<ArrowIcon />}
                      sx={{
                        mt: 3,
                        borderColor: item.color,
                        color: item.color,
                        borderRadius: '50px',
                        textTransform: 'none',
                        fontWeight: 600,
                        '&:hover': {
                          background: `${item.color}15`,
                          borderColor: item.color
                        }
                      }}
                    >
                      İncele
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Load More */}
          {filteredWidgets.length > 9 && (
            <Box sx={{ textAlign: 'center', mt: 6 }}>
              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: '#e2e8f0',
                  color: '#495057',
                  px: 6,
                  py: 2,
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  borderWidth: 2,
                  '&:hover': {
                    borderColor: '#ff6b35',
                    color: '#ff6b35',
                    borderWidth: 2
                  }
                }}
              >
                Daha Fazla Yükle
              </Button>
            </Box>
          )}
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
          py: { xs: 8, md: 10 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
            backgroundSize: '30px 30px',
            opacity: 0.5
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 3
              }}
            >
              Kendi Widget'ınızı Oluşturun
            </Typography>

            <Typography
              variant="h5"
              sx={{
                color: 'rgba(255,255,255,0.95)',
                mb: 5,
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              İhtiyacınıza özel widget geliştirme hizmeti ile 
              benzersiz tasarımlar oluşturun
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={3}
              sx={{ justifyContent: 'center' }}
            >
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'white',
                  color: '#ff6b35',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  '&:hover': {
                    background: '#f8f9fa',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
                  }
                }}
              >
                Teklif Alın
              </Button>

              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  borderWidth: 2,
                  '&:hover': {
                    background: 'rgba(255,255,255,0.1)',
                    borderColor: 'white',
                    borderWidth: 2
                  }
                }}
              >
                İletişime Geç
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>

      {/* Widget Detay Modal */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            maxHeight: '90vh'
          }
        }}
      >
        {selectedWidget && (
          <>
            <DialogTitle
              sx={{
                background: selectedWidget.color,
                color: 'white',
                p: 3
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
                    {selectedWidget.name}
                  </Typography>
                  <Typography sx={{ fontSize: '0.9rem', opacity: 0.9 }}>
                    {selectedWidget.description}
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => setOpenModal(false)}
                  sx={{
                    color: 'white',
                    '&:hover': {
                      background: 'rgba(255,255,255,0.2)'
                    }
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            </DialogTitle>

            <DialogContent sx={{ p: 4 }}>
              {/* Preview Image */}
              <Box
                sx={{
                  borderRadius: 3,
                  overflow: 'hidden',
                  mb: 4,
                  boxShadow: '0 8px 24px rgba(0,0,0,0.1)'
                }}
              >
                <img
                  src={selectedWidget.image}
                  alt={selectedWidget.name}
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </Box>

              {/* Info */}
              <Grid container spacing={3} mb={4}>
                <Grid item xs={4}>
                  <Paper sx={{ p: 2, textAlign: 'center', background: '#f8f9fa' }}>
                    <StarIcon sx={{ color: '#f59e0b', fontSize: '1.5rem', mb: 1 }} />
                    <Typography sx={{ fontWeight: 700, fontSize: '1.3rem', color: '#1a1a2e' }}>
                      {selectedWidget.rating}
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', color: '#6c757d' }}>
                      Puan
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper sx={{ p: 2, textAlign: 'center', background: '#f8f9fa' }}>
                    <CheckIcon sx={{ color: '#10b981', fontSize: '1.5rem', mb: 1 }} />
                    <Typography sx={{ fontWeight: 700, fontSize: '1.3rem', color: '#1a1a2e' }}>
                      {selectedWidget.uses}
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', color: '#6c757d' }}>
                      Kullanım
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper sx={{ p: 2, textAlign: 'center', background: '#f8f9fa' }}>
                    <CategoryIcon sx={{ color: selectedWidget.color, fontSize: '1.5rem', mb: 1 }} />
                    <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a2e' }}>
                      {categories.find(c => c.id === selectedWidget.category)?.name}
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', color: '#6c757d' }}>
                      Kategori
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>

              {/* Tags */}
              <Box sx={{ mb: 4 }}>
                <Typography sx={{ fontWeight: 700, color: '#1a1a2e', mb: 2 }}>
                  Özellikler
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                  {selectedWidget.tags.map((tag, idx) => (
                    <Chip
                      key={idx}
                      label={tag}
                      sx={{
                        background: `${selectedWidget.color}15`,
                        color: selectedWidget.color,
                        fontWeight: 600
                      }}
                    />
                  ))}
                </Stack>
              </Box>

              {/* Actions */}
              <Stack direction="row" spacing={2}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<AddIcon />}
                  sx={{
                    background: selectedWidget.color,
                    color: 'white',
                    py: 2,
                    borderRadius: '50px',
                    textTransform: 'none',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    '&:hover': {
                      background: selectedWidget.color,
                      filter: 'brightness(1.1)'
                    }
                  }}
                >
                  Widget\'ı Kullan
                </Button>
                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  sx={{
                    borderColor: selectedWidget.color,
                    color: selectedWidget.color,
                    py: 2,
                    borderRadius: '50px',
                    textTransform: 'none',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    borderWidth: 2,
                    '&:hover': {
                      background: `${selectedWidget.color}10`,
                      borderWidth: 2
                    }
                  }}
                >
                  Daha Fazla Bilgi
                </Button>
              </Stack>
            </DialogContent>
          </>
        )}
      </Dialog>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes morph {
          0%, 100% {
            border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
          }
          25% {
            border-radius: 60% 40% 50% 50% / 30% 60% 40% 60%;
          }
          50% {
            border-radius: 50% 50% 30% 70% / 50% 30% 70% 40%;
          }
          75% {
            border-radius: 30% 70% 60% 40% / 60% 40% 50% 50%;
          }
        }
      `}</style>
    </Box>
  );
};

export default WidgetGalleryPage;